import clsx from "clsx";
import React from "react";
import { BackgroundColor } from "@silversea-ssc/ui-components-react";
import styles from "./SliderControls.module.scss";
import { Trans } from "@lingui/react/macro";
import { PrevButton } from "../PaginationButtons/PrevButton";
import { NextButton } from "../PaginationButtons/NextButton";

export type SliderControlsProps = {
  totalPages: number;
  currentSlideIndex: number;
  isBeginning: boolean;
  isEnd: boolean;
  prevSlide: () => void;
  nextSlide: () => void;
  className?: string;
  variantColor?: BackgroundColor;
  whiteControls?: boolean;
};

export const SliderControls: React.FC<SliderControlsProps> = ({
  totalPages,
  currentSlideIndex,
  isBeginning,
  isEnd,
  nextSlide,
  prevSlide,
  //labels,
  className,
  variantColor = "neutral05",
  whiteControls
}) => {
  return (
    <div
      data-content-name="slider-controls"
      className={clsx(styles.controls, className, {
        [styles.variantGray]: variantColor === "neutral05",
        [styles.variantWhite]: variantColor === "white",
        [styles.variantTitanium]: variantColor === "titanium"
      })}
    >
      <div className={styles.controlsLeft}>
        <div className={styles.scrollbar} aria-hidden={true}>
          <div
            className={styles.scrollbarStepActive}
            style={{
              width: `calc(100% / ${totalPages})`,
              transform: `translateX(calc(${currentSlideIndex} * 100%))`
            }}
          ></div>
          <div className={styles.scrollbarStep}></div>
        </div>
        <SliderControlTotalPages
          currentPage={currentSlideIndex}
          totalPages={totalPages}
        />
      </div>
      <div className={styles.buttons}>
        <PrevButton
          dataContentPiece="slider_previous_button"
          disabled={isBeginning}
          onClick={prevSlide}
          variant={whiteControls ? "elevated" : "secondary"}
          inverted={variantColor === "titanium"}
        />
        <NextButton
          dataContentPiece="slider_next_button"
          disabled={isEnd}
          onClick={nextSlide}
          variant={whiteControls ? "elevated" : "secondary"}
          inverted={variantColor === "titanium"}
        />
      </div>
    </div>
  );
};

type SliderControlTotalPagesProps = {
  currentPage: number;
  totalPages: number;
  className?: string;
};

export const SliderControlTotalPages: React.FC<
  SliderControlTotalPagesProps
> = ({ currentPage, totalPages, className }) => {
  return (
    <div className={clsx(styles.counter, className)}>
      {currentPage + 1} <Trans id="counter-separator">of</Trans> {totalPages}
    </div>
  );
};
